export default __webpack_public_path__ + "static/media/Snd_TryO.81076af1.mp3";